import React, { useState, useCallback, useEffect } from 'react';
import { TEstimateItem } from '../types/estimate/estimate';
import { TSetLocalStorage } from '../pages/EditEstimates';
import { convertToHalfWidthNumeric } from '../utils/toHalfWidth';
import { TUpdateEstimateItemList } from '../types/estimate/estimate';

type EstimateItemInputProps = {
  estimateItemList: TEstimateItem[];
  item: any;
  indexes: number[];
  updateEstimateItemList: TUpdateEstimateItemList;
  fieldName: 'quantity' | 'costQuantity' | 'grossProfitMargin';
  minValue: number;
  maxValue: number;
  setLocalStorage: TSetLocalStorage;
  classes: any;
  classNameString: string;
};

export const EstimateItemInput = (props: EstimateItemInputProps) => {
  const {
    estimateItemList,
    item,
    indexes,
    updateEstimateItemList,
    fieldName,
    minValue,
    maxValue,
    setLocalStorage,
    classes,
    classNameString
  } = props;

  /**
   *
   * @param item 見積書項目
   * @param fieldName 見積書項目のフィールド名
   * @returns 見積書項目の指定されたフィールドに対して
   *          フィールドごとの適切な処理を施されたもの
   */
  const getItemValueByFieldName = (
    item: any,
    fieldName: string
  ): string | number => {
    switch (fieldName) {
      case 'quantity':
        return item.quantity;
      case 'costQuantity':
        return item.costQuantity;
      case 'grossProfitMargin':
        return isNaN(parseFloat(item.grossProfitMargin))
          ? ''
          : parseFloat(item.grossProfitMargin);
      default:
        return '';
    }
  };

  /**
   * 見積書項目の指定されたフィールドに対して
   * フィールドに応じたdisableの判定処理をする
   *
   * @param item 見積書項目
   * @param fieldName 見積書項目のフィールド名
   * @returns disabled
   */
  const judgeDisabled = (item: any, fieldName: string) => {
    switch (fieldName) {
      case 'quantity':
        return false;

      case 'costQuantity':
        return false;
      case 'grossProfitMargin':
        return item.hasUnderLayerFlg === true;
    }
  };

  const [text, setText] = useState(getItemValueByFieldName(item, fieldName));

  // 他のフィールドの値が変更された時に自動的に変更される
  // フィールド(数量が変更された時の原価数量など)は、useStateでは自動的に
  // 変更が反映されないため、useEffectで変更を検知している。
  useEffect(() => {
    setText(getItemValueByFieldName(item, fieldName));
  }, [item[fieldName]]);

  return (
    <input
      value={text}
      disabled={judgeDisabled(item, fieldName)}
      type='text'
      onChange={event => setText(event.target.value)}
      onBlur={event => {
        let input = event.target.value;
        // 入力内容に変更があった場合のみ以下の処理を実行
        if (input !== getItemValueByFieldName(item, fieldName).toString()) {
          // 入力文字列を半角の数字に自動変換
          input = convertToHalfWidthNumeric(input, minValue, maxValue);
          setText(input);
          updateEstimateItemList(
            { key: fieldName, value: parseFloat(input) },
            indexes
          );
          setLocalStorage('estimateItemList', JSON.stringify(estimateItemList));
        }
      }}
      className={classes[classNameString]}
      onWheel={(e: any) => e.target.blur()}
    />
  );
};
